import React from "react";
import SchoolIcon from '@material-ui/icons/School';
import ComputerIcon from '@material-ui/icons/Computer';
import { Box, Typography, Divider, Grid } from "@material-ui/core";
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import moment from "moment";

const UserDetailModule = ({ program }) => {
  if (!program) {
    return <div>Loading...</div>;
  }

  return (
    <Box>
      <Box sx={{
        backgroundColor: '#FAFAFA',
        mt: 2,
        borderRadius: '12px',
        padding: '10px',
      }}>
        {/* Modal Header */}
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <img
            src={
              program.program_image_url
                ? program.program_image_url
                : "https://t4.ftcdn.net/jpg/05/17/53/57/360_F_517535712_q7f9QC9X6TQxWi6xYZZbMmw5cnLMr279.jpg"
            }
            alt="Program"
            width={534}
            height={319}
            style={{
              width: '504',
              height: '370',
              borderRadius: '8px',
              paddingBottom: '10px',
            }}
          />
          <Box sx={{ display: 'flex', flexDirection: "column", alignItems: 'center' }}>
            <img
              src="https://careertrainingprogram.vercel.app/assets/images/logo1.svg"
              alt="Logo"
              width={120}
              height={70}
              style={{ marginTop: '20px' }}
            />
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="h4" style={{ fontWeight: '600', marginTop: '16px' }}>
                Code : {program.program_code || 'N/A'}
              </Typography>
              <Typography style={{ visibility: "hidden" }} variant="body1" sx={{ pt: 1.5 }}>
                {/* &nbsp */}
                My name is Kenneth and I've been helping people gain confidence speaking in public, give a "killer speech," and nail the interview for over five years.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Cards */}
      <Grid container spacing={3} style={{ marginTop: 5 }}>
        <Grid item xs={12} md={3}>
          <Box sx={{ display: 'block', border: '1px solid #c5c6c7', alignItems: 'center', borderRadius: 4, p: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 1, width: '100%' }}>
              <AccessTimeIcon style={{ height: '2.5rem', width: 'auto' }} />
              <Typography variant="h6" style={{ fontWeight: 600, textAlign: 'center' }}>Estimated Time</Typography>
            </Box>
            <Box sx={{ padding: 1, display: program.estimated_time ? 'block' : 'flex', justifyContent: 'center', width: '100%' }}>
              <Typography variant="h6" className="font-bold text-xl">{moment(program.estimated_time).format("DD/MM/YYYY") || 'N/A'}</Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={3}>
          <Box sx={{ display: 'block', border: '1px solid #c5c6c7', alignItems: 'center', borderRadius: 4, p: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 1, width: '100%' }}>
              <ComputerIcon style={{ height: '2.5rem', width: 'auto' }} />
              <Typography variant="h6" style={{ fontWeight: 600, textAlign: 'center' }}>Learning Model</Typography>
            </Box>
            <Box sx={{ padding: 1, display: program.learning_model ? 'block' : 'flex', justifyContent: 'center', width: '100%' }}>
              <Typography variant="h6">{program.learning_model || 'N/A'}</Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={3}>
          <Box sx={{ display: 'block', border: '1px solid #c5c6c7', alignItems: 'center', borderRadius: 4, p: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 1, width: '100%' }}>
              <SchoolIcon style={{ height: '2.5rem', width: 'auto' }} />
              <Typography variant="h6" style={{ fontWeight: 600, textAlign: 'center' }}>Course</Typography>
            </Box>
            <Box sx={{ padding: 1, display: program.course_type ? 'block' : 'flex', justifyContent: 'center', width: '100%' }}>
              <Typography variant="h6">{program.course_type || 'N/A'}</Typography>
            </Box>
          </Box>
        </Grid>

        <Grid item xs={12} md={3}>
          <Box sx={{ display: 'block', border: '1px solid #c5c6c7', alignItems: 'center', borderRadius: 4, p: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 1, width: '100%', }}>
              <AttachMoneyIcon style={{ height: '2.5rem', width: 'auto' }} />
              <Typography variant="h6" style={{ fontWeight: 600, textAlign: 'center' }}>Total Cost</Typography>
            </Box>
            <Box sx={{ padding: 1, display: program.total_cost ? 'block' : 'flex', justifyContent: 'center', width: '100%' }}>
              <Typography variant="h6">{program.total_cost ? `Total Cost $ ${program.total_cost}` : 'N/A'}</Typography>
            </Box>
          </Box>
        </Grid>
      </Grid>

      {/* Description */}
      <Box sx={{ mt: 3 }}>
        <Box style={{ padding: '10px', borderRadius: '5px', boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px" }}>
          <Typography variant="h5" style={{ fontWeight: 600 }}>Description</Typography>
          <Typography variant="body1" style={{ color: "#1E1E1E" }}>
            {program.program_description || 'N/A'}
          </Typography>
        </Box>

        <Grid container spacing={3} style={{ marginTop: 5 }}>
          <Grid item xs={12} sm={6}>
            <Box style={{ padding: '10px', borderRadius: '5px', boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px" }}>
              <Typography variant="h5" style={{ fontWeight: 600 }}>Program Objective</Typography>
              <Typography variant="body1" style={{ color: "#1E1E1E" }}>
                {program.program_objective || 'N/A'}
              </Typography>
            </Box>

            <Box style={{ padding: '10px', borderRadius: '5px', boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px", marginTop: '10px' }}>
              <Typography variant="h5" style={{ fontWeight: 600 }}>Requirements</Typography>
              <Typography variant="body1" style={{ color: "#1E1E1E" }}>
                {program.general_requirements || 'N/A'}
              </Typography>
            </Box>

            <Box style={{ padding: '10px', borderRadius: '5px', boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px", marginTop: '10px' }}>
              <Typography variant="h5" style={{ fontWeight: 600 }}>Course Material</Typography>
              <Typography variant="body1" style={{ color: "#1E1E1E" }}>
                {program.course_materials || 'N/A'}
              </Typography>
            </Box>

            <Box style={{ padding: '10px', borderRadius: '5px', boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px", marginTop: '10px' }}>
              <Typography variant="h5" style={{ fontWeight: 600 }}>Instructors</Typography>
              <Typography variant="body1" style={{ color: "#1E1E1E" }}>
                {program.instructors || 'N/A'}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box style={{ padding: '10px', borderRadius: '5px', boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px" }}>
              <Typography variant="h5" style={{ fontWeight: 600, textAlign: 'center', paddingBottom: '4px' }}>Enrollment Details</Typography>


              <Grid container style={{ marginTop: '20px' }}>
                <Grid item xs={6} style={{ borderRight: '1px solid #c5c6c7', padding: '6px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Typography variant="h5" style={{ fontWeight: 600 }}>Term</Typography>
                  <Typography variant="body1" style={{ color: "#1E1E1E", marginTop: '4px' }}>
                    Open Enrollment
                  </Typography>
                </Grid>

                <Grid item xs={6} style={{ padding: '6px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Typography variant="h5" style={{ fontWeight: 600 }}>Start Date</Typography>
                  <Typography variant="body1" style={{ color: "#1E1E1E", marginTop: '4px' }}>
                    { program.start_date ? moment(program.start_date).format("DD/MM/YYYY") : "N/A" }
                  </Typography>
                </Grid>

                <Grid item xs={6} style={{ borderRight: '1px solid #c5c6c7', marginTop: '20px', padding: '6px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Typography variant="h5" style={{ fontWeight: 600 }}>Add Date</Typography>
                  <Typography variant="body1" style={{ color: "#1E1E1E", marginTop: '4px' }}>
                    { program.add_date ? moment(program.add_date).format("DD/MM/YYYY") : "N/A" }
                  </Typography>
                </Grid>

                <Grid item xs={6} style={{ padding: '6px', textAlign: 'center', marginTop: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <Typography variant="h5" style={{ fontWeight: 600 }}>Drop Date</Typography>
                  <Typography variant="body1" style={{ color: "#1E1E1E", marginTop: '4px' }}>
                    { program.drop_date ? moment(program.drop_date).format("DD/MM/YYYY") : "N/A" }
                  </Typography>
                </Grid>
              </Grid>
            </Box>

            <Box style={{ padding: '10px', borderRadius: '5px', boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px", marginTop: '10px' }}>
              <Typography variant="h5" style={{ fontWeight: 600 }}>Career Opportunities</Typography>
              <Typography variant="body1" style={{ color: "#1E1E1E" }}>
                {program.career_opportunities || 'N/A'}
              </Typography>
            </Box>

            <Box style={{ padding: '10px', borderRadius: '5px', boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px", marginTop: '10px' }}>
              <Typography variant="h5" style={{ fontWeight: 600 }}>Outcomes</Typography>
              <Typography variant="body1" style={{ color: "#1E1E1E" }}>
                {program.program_outcomes || 'N/A'}
              </Typography>
            </Box>

            <Box style={{ padding: '10px', borderRadius: '5px', boxShadow: "rgba(0, 0, 0, 0.1) 0px 0px 5px 0px, rgba(0, 0, 0, 0.1) 0px 0px 1px 0px", marginTop: '10px' }}>
              <Typography variant="h5" style={{ fontWeight: 600 }}>Additional Costs</Typography>
              <Typography variant="body1" style={{ color: "#1E1E1E" }}>
                {program.additional_costs || 'N/A'}
              </Typography>
            </Box>
          </Grid>
        </Grid>

      </Box>
    </Box >
  );
};

export default UserDetailModule;
